/* ==========================================================================
   Tiny Slider
   ========================================================================== */

// ...

import { tns } from "tiny-slider/src/tiny-slider";

var storySlider = document.getElementById("neighbourhood-stories");
const storySlide = document.querySelectorAll(".story-slide").length;

if (storySlide < 2) {
  var storyLength = 1;
} else {
  var storyLength = 2;
}

if (storySlider != null) {
  const slider1 = tns({
    container: ".story-slider",
    items: 1,
    slideBy: 1,
    autoplay: false,
    controlsContainer: "#customize-controls",
    controls: true,
    navPosition: "bottom",
    nav: true,
    mouseDrag: true,
    gutter: 20,
    preventScrollOnTouch: "auto",
    swipeAngle: 45,
    responsive: {
      700: {
        items: storyLength,
      },
    },
  });
}

var gallerySlider = document.getElementById("gallery-slider");
if (gallerySlider != null) {
  const slider2 = tns({
    container: ".gallery-slider__slide",
    items: 1,
    slideBy: 1,
    autoplay: false,
    controlsContainer: "#customize-gallery-controls",
    controls: true,
    navPosition: "bottom",
    nav: true,
    gutter: 10,
    mouseDrag: true,
    preventScrollOnTouch: "auto",
    swipeAngle: 45,
  });
}

var propertySlider = document.getElementById("property-slider");
const propertySlide = document.querySelectorAll(".property-slide").length;
const propertyClassWrap = document.querySelector(".property-slide__wrap");
const propertyMetaClassWrap = document.querySelector(".property-slide");

if (propertySlide > 2) {
  var propertyLength = 2;
  var propertyLengthWide = 3;
} else if (propertySlide == 2) {
  var propertyLength = 2;
  var propertyLengthWide = 2;
} else {
  var propertyLength = 1;
  var propertyLengthWide = 1;
  propertyClassWrap?.classList.add("lg:h-500");
  propertyMetaClassWrap?.classList.add("property-wide");
}

if (propertySlider != null) {
  const slider3 = tns({
    container: ".show-properties__slider",
    items: 1,
    slideBy: 1,
    autoplay: false,
    controlsContainer: "#customize-property-controls",
    nav: true,
    controls: true,
    navPosition: "bottom",
    mouseDrag: true,
    gutter: 20,
    preventScrollOnTouch: "auto",
    swipeAngle: 45,
    responsive: {
      700: {
        items: propertyLength,
      },
      1100: {
        items: propertyLengthWide,
      },
    },
  });
}

const relatedStories = document.getElementById("related-stories");
const relatedSlide = document.querySelectorAll(".story-slide-2").length;
const storyClassWrap = document.querySelector(".story-slide-2__wrap");

if (relatedSlide > 2) {
  var relatedLength = 2;
  var relatedLengthWide = 3;
} else if (relatedSlide == 2) {
  var relatedLength = 2;
  var relatedLengthWide = 2;
} else {
  var relatedLength = 1;
  var relatedLengthWide = 1;
  storyClassWrap?.classList.add("max-h-500");
}
if (relatedStories != null) {
  const relatedStoriesSlider = tns({
    container: ".related-stories__slider",
    items: 1,
    slideBy: 1,
    autoplay: false,
    controlsContainer: "#customize-related-controls",
    nav: true,
    controls: true,
    navPosition: "bottom",
    mouseDrag: true,
    gutter: 20,
    preventScrollOnTouch: "auto",
    swipeAngle: 45,
    responsive: {
      700: {
        items: relatedLength,
      },
      1100: {
        items: relatedLengthWide,
      },
    },
  });
}
